import { Button, PageHeader, Tabs } from 'antd'
import get from 'lodash.get'
import React, { useState } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import EditOrderPayment from './edit/EditOrderPayment'
import EditOrderDetail from './edit/EditOrderDetail'
import EditOrderEditMeasure from './edit/EditOrderEditMeasure'
import EditOrderEditAdjustment from './edit/EditOrderEditAdjustment'
import EditOrderEditOrderInfos from './edit/EditOrderEditOrderInfos'
import Error from '../../components/Error'
import Loader from '../../components/Loader'
import { getOrderDetails } from '../../network/Orders'
import { createUrlWithFiltersFromCurrentURL } from '../../utils/filterUtils'

const EditOrder = ({ history }) => {
  const { orderId, storeId } = useParams()
  const queryClient = useQueryClient()
  const [measureSelected, setMeasureSelected] = useState(null)
  const [mainTab, setMainTab] = useState('1')
  const [editOpenOnTab, setEditOpenOnTab] = useState('0')

  // ─── Data: order details ─────────────────────────────────────────────────
  const keyQuery = ['getOrderDetails', { id: orderId }]
  const orderDetails = useQuery(keyQuery, getOrderDetails, {
    refetchOnWindowFocus: false,
  })

  const isFastSale = get(orderDetails, 'data.orderType') === 'fast_sale'
  // ─── Handlers ─────────────────────────────────────────────────────────────
  const handleGoBack = () => {
    const url = createUrlWithFiltersFromCurrentURL('/orders')
    history.push(url)
  }

  // ─── Render: tabs (Payment / Details) and measure edit views ──────────────
  return (
    <>
      <PageHeader
        className="site-page-header"
        title={
          measureSelected === null
            ? 'Order summary'
            : get(
                orderDetails,
                `data.orderProducts.${measureSelected}.orderProductType`,
                ''
              ) === 'adjustment'
            ? 'Edit Adjustment'
            : get(orderDetails, 'data.validated', false)
            ? 'Edit'
            : 'Edit Measures'
        }
        onBack={
          measureSelected === null
            ? handleGoBack
            : () => {
                setMeasureSelected(null)
                setMainTab('2')
              }
        }
        style={{ backgroundColor: '#fff' }}
      />
      {orderDetails.isError ? (
        <Error retry={() => orderDetails.refetch()} />
      ) : orderDetails.isLoading ? (
        <Loader />
      ) : measureSelected === null ? (
        <Tabs
          className="orders-tabs"
          activeKey={mainTab}
          onChange={setMainTab}
          tabBarExtraContent={
            !isFastSale ? (
              <Button
                disabled={
                  orderDetails.isLoading ||
                  get(orderDetails, 'data.validated', false)
                }
                onClick={() =>
                  history.push(`/orders/${orderId}/edit/store/${storeId}`)
                }
              >
                Add sku
              </Button>
            ) : null
          }
          items={[
            {
              key: '1',
              label: 'Payment',
              children: (
                <EditOrderPayment
                  data={get(orderDetails, 'data', {})}
                  orderId={orderId}
                />
              ),
            },
            {
              key: '2',
              label: 'Details',
              children: (
                <EditOrderDetail
                  data={get(orderDetails, 'data', {})}
                  editMeasure={(index, tab) => {
                    setMeasureSelected(index)
                    setEditOpenOnTab(tab ?? '0')
                  }}
                  validate={() =>
                    queryClient.setQueryData(keyQuery, (oldData) => ({
                      ...oldData,
                      validated: true,
                    }))
                  }
                />
              ),
            },
          ]}
        />
      ) : get(
          orderDetails,
          `data.orderProducts.${measureSelected}.orderProductType`,
          ''
        ) === 'adjustment' ? (
        <EditOrderEditAdjustment
          closeMeasure={() => {
            setMeasureSelected(null)
            setMainTab('2')
          }}
          data={get(orderDetails, 'data', {})}
          productIndex={measureSelected}
        />
      ) : get(orderDetails, 'data.validated', false) ? (
        <EditOrderEditMeasure
          closeMeasure={() => {
            setMeasureSelected(null)
            setMainTab('2')
          }}
          data={get(orderDetails, 'data', {})}
          productIndex={measureSelected}
        />
      ) : (
        <EditOrderEditOrderInfos
          key={`edit-infos-${measureSelected}-${editOpenOnTab}`}
          closeMeasure={() => {
            setMeasureSelected(null)
            setMainTab('2')
          }}
          data={get(orderDetails, 'data', {})}
          productIndex={measureSelected}
          initialTab={editOpenOnTab}
        />
      )}
    </>
  )
}

export default EditOrder
